export const moneyTree = {
  startLuck: '7882.0 ', // 点击开始抽奖
  gotoRule: '7883.0', // 点击页面规则
  myRecords: '7884.0', // 点击我的奖品
  money_tree_1: '7896.0',
  money_tree_2: '7897.0',
  money_tree_3: '7898.0',
  money_tree_4: '7899.0',
  money_tree_5: '7900.0',
  money_tree_6: '7901.0'
}
